export function getCaseHistoryData(){
  return {
    dataColumns:[
      {
          name: 'Date',
          displayType: 'DATE',
          columnKey: 'eventTimeStamp',
          width: '15vw',
      },
      {
          name: 'Stage',
          displayType: 'STRING',
          columnKey: 'disputeStageName',
          width: '10vw',
      },
      {
          name: 'User',
          displayType: 'STRING',
          columnKey: 'eventGeneratedByUser',
          width: '7vw',
      },
      {
          name: 'Event Description',
          displayType: 'STRING',
          columnKey: 'eventVerbiage',
          width: '26vw',
      }
    ]
  }
}